import * as React from 'react';
import axios from 'Src/helpers/api/axiosInstance';
import { getActiveSchoolId, getSessions } from 'Src/helpers/session/session';

export const REPORT_TRAIT_FIELDS = {
  isPrintPP: 'pupilsPremium',
  isPrintSEN: 'specialEducationNeeds',
  isPrintFSM: 'freeSchoolMeals',
  isPrintEthnicity: 'ethnicityCode'
};
const pending = new Map<string, Promise<string[]>>();
export function useReportTraitOptions(enabled = true) {
  const schoolId = getActiveSchoolId();
  const session = getSessions().roleSession;
  const key = session && session.key;
  const context = `${schoolId}:${key}`;
  const [state, setState] = React.useState<{ context: string; fields: string[] }>({ context: '', fields: [] });
  React.useEffect(() => {
    if (!enabled || !schoolId || !key) return;
    let active = true;
    let request = pending.get(context);
    if (!request) {
      request = axios
        .get(`${window.apiBase}/i/schools/${schoolId}/report/options`, { headers: { usid: key } })
        .then(response => (Array.isArray(response.data.traitFields) ? response.data.traitFields : []))
        .catch(() => []);
      pending.set(context, request);
      request.then(() => pending.delete(context));
    }
    request.then(fields => {
      if (active) setState({ context, fields });
    });
    return () => {
      active = false;
    };
  }, [enabled, context]);
  const fields = state.context === context ? state.fields : [];
  return (name: string) => !REPORT_TRAIT_FIELDS[name] || fields.includes(REPORT_TRAIT_FIELDS[name]);
}
